import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import clsx from 'clsx';

import { HeadingArticle, HeadingPara } from './Headings';
import Paragraph from './Paragraph';

const HeadingRenderer = ({ level, children }) => {
  switch (level) {
    case 1:
      return <HeadingArticle el="h1">{children}</HeadingArticle>;
    case 2:
      return <HeadingArticle>{children}</HeadingArticle>;
    case 3:
      return <HeadingPara el="h2">{children}</HeadingPara>;
    case 4:
    default:
      return <HeadingPara el="h3">{children}</HeadingPara>;
  }
};

HeadingRenderer.propTypes = {
  level: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

const FeatureHeadlineRenderer = ({ index, children }) => (
  <Paragraph headline={index === 0} secondary={index !== 0}>{children}</Paragraph>
);

FeatureHeadlineRenderer.propTypes = {
  index: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

const HeadlineRenderer = ({ children }) => (
  <Paragraph headline>{children}</Paragraph>
);

HeadlineRenderer.propTypes = {
  children: PropTypes.node.isRequired,
};

const ParagraphRenderer = ({ children }) => (
  <Paragraph>{children}</Paragraph>
);

ParagraphRenderer.propTypes = {
  children: PropTypes.node.isRequired,
};

const SecondaryRenderer = ({ children }) => (
  <Paragraph secondary>{children}</Paragraph>
);

SecondaryRenderer.propTypes = {
  children: PropTypes.node.isRequired,
};

const RichText = ({
  content, paragraphRenderer, className, ...rest
}) => (
  <ReactMarkdown
    source={content}
    includeNodeIndex
    renderers={{
      heading: HeadingRenderer,
      paragraph: paragraphRenderer,
    }}
    className={clsx('ss_rich_text', className)}
    {...rest}
  />
);

RichText.propTypes = {
  content: PropTypes.string.isRequired,
  paragraphRenderer: PropTypes.func,
  className: PropTypes.string,
};

RichText.defaultProps = {
  paragraphRenderer: ParagraphRenderer,
  className: undefined,
};

export { FeatureHeadlineRenderer, HeadlineRenderer, SecondaryRenderer };
export default RichText;
